import React from "react";

const ServiceCost = ({ row }) => {
  return (
    <div>
      {row.services?.map((service, index) => (
        <div style={{ paddingBottom: "10px", width: "120px" }} key={index}>
          {service?.cost?.toLocaleString()}
        </div>
      ))}
    </div>
  );
};

export default ServiceCost;
